var Product = {
  INIT: 0,
  X18: 1,
  TEST: 2,
  DELETE: 3,
  properties: {
    0: { name: 'INIT', value: 0 },
    1: { name: 'X18', value: 1 },
    2: { name: 'TEST', value: 2 },
    3: { name: 'DELETE', value: 3 }
  }
}
module.exports = {
  Product: Product
}



// WEBPACK FOOTER //
// ./src/assets/js/state.js